import { useTranslate } from 'ra-core'
import { memo } from 'react'
import { makeOpenSolarStyles } from 'themes/makeOpenSolarStyles'

const useStyles = makeOpenSolarStyles((theme) => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    height: '15px',
    fontSize: '12px',
    borderRadius: '4px',
    padding: '3px 10px',
    backgroundColor: theme.palette.error.dark,
    color: theme.white,
    width: 'fit-content',
  },
}))

const PercentageDiscountTag = ({ showUpTo, percentage }: { showUpTo: boolean; percentage: string }) => {
  const classes = useStyles()
  const translate = useTranslate()
  return (
    <div className={classes.wrapper}>
      {showUpTo
        ? translate('UP TO %{percentage}% OFF', { percentage })
        : translate('%{percentage}% OFF', { percentage })}
    </div>
  )
}

export default memo(PercentageDiscountTag)
